<script>
import * as d3 from "d3";
import { D3Utility } from "../services/d3_utility.js";
import { Library } from "@observablehq/stdlib/";

const moment = require("moment-timezone");
const DATETIME_FORMAT = moment.tz.guess().split("/")[0] == "America" ? "MM/DD/YYYY, HH:mm" : "DD/MM/YYYY, HH:mm";

export default {
  name: "TimelineChart",
  props: {
    data: {
      required: true,
      type: Array,
    },
    chartData: {
      required: true,
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      svg: null,
      div: null,
      show_tooltip: false,
    };
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    initialize() {
      setTimeout(() => {
        if (this.svg) this.svg.remove();
        this.init();
      }, 1000);
    },
    init() {
      if (this.data) {
        this.div = D3Utility.append_tooltip();
        this.drawChart();
      }
    },
    drawChart() {
      let self = this;
      const width = D3Utility.get_conatiner_width(".container");
      this.width = width;
      const height = this.data && this.data.length > 0 ? 25 * this.data.length + 100 : 200;
      const legendHeight = 30;
      const margin = 30;
      const padding = 0;
      this.chart_config = {
        width,
        height,
        legendHeight,
        margin,
        padding,
      };
      this.svg = D3Utility.create_svg(this.chartData.id, this.chart_config);

      this.zoom = d3
        .zoom()
        .scaleExtent([0.5, 32])
        .extent([
          [0, 0],
          [
            this.chart_config.width - this.chart_config.margin,
            this.chart_config.height - (this.chart_config.margin + this.chart_config.padding),
          ],
        ])
        .on("zoom", zoomed);

      // D3Utility.define_zoom(this.chart_config, zoomed);

      const library = new Library();
      this.clip = library.DOM.uid("clip");

      this.svg = D3Utility.append_clip_path(this.chart_config, this.clip, this.svg);
      let date_extent = d3.extent(this.data, function (d) {
        return d ? d.start : null;
      });
      this.date_extent = d3.extent(this.data, function (d) {
        return d ? d.end : null;
      });
      this.xScale = D3Utility.get_utc_scale([margin, width - margin - padding]);
      this.xScale.domain([date_extent[0], this.date_extent[1]]);
      //-----------------------------AXES-----------------------------//
      this.xaxis = (g, x) =>
        g
          .attr("transform", `translate(${margin},${height - margin})`)
          .call(D3Utility.define_bottom_axis(x, width, false));
      this.gx = D3Utility.append_axis(this.svg, this.xaxis, this.xScale, padding, height);
      this.gx
        .append("text")
        .attr("x", "650px")
        .attr("y", "40px")
        .attr("text-anchor", "middle")
        .text(this.chartData.xAxis);

      this.lines = this.svg
        .selectAll("lines")
        .data(this.data)
        .enter()
        .append("g")
        .attr("transform", "translate(" + margin + ",-50)")
        .attr("class", `lines`)
        .each(function (d, i) {
          d3.select(this)
            .append("rect")
            // .attr("clip-path", self.clip)
            .attr("x", self.xScale(d.start))
            .attr("width", self.xScale(d.end) - self.xScale(d.start) || 30)
            .attr("y", self.chart_config.height - i * 15 * 1.2)
            .attr("height", 20)
            .attr("opacity", 0.7)
            .attr("stroke", "grey")
            .attr("stroke-width", 1)
            .attr("fill", d.type == "Variation" ? "yellow" : d.type == "Event" ? "orange" : "red")
            .on("mouseover", function (event, elem) {
              self.div.transition().duration(100).style("opacity", 1);
              self.div
                .html(
                  `<div class='mb-2 font-weight-bold'> 
              ${elem.start ? elem.start : "-"}
               <div class='primaryGrey--text caption'> 
              ${moment(Number(elem.start)).format(DATETIME_FORMAT)} : <b>${D3Utility.format_duration(
                    Number(elem.duration)
                  )}</b>
              </div></div><div class='primary--text caption mb-2'> 
              ${elem.type ? elem.type : ""}  - ${elem.label ? elem.label : ""} 
              </div>`
                )
                .style("left", event.pageX - 100 + "px")
                .style("top", event.pageY - 150 + "px")
                .style("width", "210px")
                .style("height", "100px");
              d3.select(this).node() && d3.select(this).node().classList.toggle("highlight");
            })
            .on("mouseout", function () {
              d3.selectAll(".grid-line").remove();
              self.div.transition().duration(100).style("opacity", 0).style("width", "210px").style("height", "100px");
              d3.select(this).node() && d3.select(this).node().classList.toggle("highlight");
            });
          d3.select(this)
            .append("text")
            .attr("x", self.xScale(d.start))
            .attr("y", self.chart_config.height - i * 15 * 1.2 + 9)
            .attr("text-anchor", "start")
            .attr("font-size", 14)
            .attr("font-weight", "bold")
            .attr("fill", "grey")
            .text(d.label)
            .on("mouseover", function (event, elem) {
              self.div.transition().duration(200).style("opacity", 1);
              self.div
                .html(
                  `<div class='mb-2 font-weight-bold'> 
              ${elem.start ? elem.start : "-"}
               <div class='primaryGrey--text caption'> 
              ${moment(Number(elem.start)).format(DATETIME_FORMAT)} : <b>${D3Utility.format_duration(
                    Number(elem.duration)
                  )}</b>
              </div></div><div class='primary--text caption mb-2'> 
              ${elem.type ? elem.type : ""}  - ${elem.label ? elem.label : ""} 
              </div>`
                )
                .style("left", event.pageX - 100 + "px")
                .style("top", event.pageY - 150 + "px")
                .style("width", "210px")
                .style("height", "100px");
              d3.select(this).node() && d3.select(this).node().classList.toggle("highlight");
            })
            .on("mouseout", function () {
              d3.selectAll(".grid-line").remove();
              self.div.transition().duration(200).style("opacity", 0).style("width", "210px").style("height", "100px");
              d3.select(this).node() && d3.select(this).node().classList.toggle("highlight");
            });
        });
      this.svg.call(this.zoom).transition().duration(750).call(this.zoom.scaleTo, 0.5);
      // const handleZoom = (e) => this.svg.attr("transform", e.transform);

      function zoomed(event) {
        if (event && self.svg && self.chartData) {
          const xz = event.transform.rescaleX(self.xScale);
          self.gx.call(self.xaxis, xz);
          self.lines
            .selectAll("rect")
            .attr("x", (d) => xz(d.start))
            .attr("width", (d) => xz(d.end) - xz(d.start) || 30);
          self.lines.selectAll("text").attr("x", (d) => xz(d.start));
        }
      }

      // const zoom = d3.zoom().on("zoom", handleZoom);

      // d3.select("svg").call(zoom);
    },
  },
  computed: {},
};
</script>

<template>
  <div>
    <v-skeleton-loader v-if="!chartData || !data" type="image"></v-skeleton-loader>
    <div class="pa-4 text-caption font-weight-bold primaryGrey--text" v-if="chartData && data.length == 0">
      No data available.
    </div>
    <div :id="`con_${chartData.id}`" class="container pa-0">
      <div :id="`${chartData.id}`" class="svg-container"></div>
    </div>
  </div>
</template>

<style lang="scss">
@keyframes highlight {
  0% {
    fill: #c63e12;
  }

  50% {
    fill: rgb(221, 53, 53);
  }
}

@keyframes highlightStroke {
  0% {
    stroke: #c63e12;
  }

  50% {
    stroke: rgb(221, 53, 53);
  }
}

@keyframes dash {
  from {
    stroke-dashoffset: 50;
  }

  to {
    stroke-dashoffset: 10;
  }
}

@keyframes dashError {
  from {
    stroke-dashoffset: 10;
  }

  to {
    stroke-dashoffset: 50;
  }
}

.info {
  font-size: 0.11rem;
}

.stats {
  color: white;
}

.warning {
  fill: #c63e12;
  font-weight: bold;
  animation-name: highlight;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  cursor: pointer;
}

.warning path.icon {
  stroke: #c63e12;
  animation-name: highlightStroke;
  animation-duration: 1s;
  animation-iteration-count: infinite;
}

.warning path.shadow {
  stroke: grey;
  animation: none;
}

/* axis text */
.axis text {
  fill: var(--v-titleLight-base);
  font-family: "Roboto", sans-serif;
  // font-size: 120%;
  font-size: 1rem;
}

.positive-flow {
  stroke-dasharray: 1;
  animation: dash 5s linear infinite;
}

.negative-flow {
  stroke-dasharray: 1;
  animation: dashError 5s linear infinite;
}

.width-20 {
  width: 19%;
}

.width-70 {
  width: 68%;
}

.width-10 {
  width: 13%;
}

.width-9 {
  width: 9%;
}

.width-50 {
  width: 50%;
}

.width-31 {
  width: 31%;
}

.pointer {
  cursor: pointer;
}
</style>
